import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import React, { useContext, useEffect, useState } from "react";
import ContentLayout from "../../component/ContentLayout";
import { useParams } from "react-router-dom";
import { Context } from "../../component/Context/ErrorContext";
import axios from "../../util/axios";
import CompanyModal from "../../component/CompanyModal";
import Select from "react-select";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import moment from "moment";

const Company = () => {
  const { setError } = useContext(Context);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [companyData, setCompanyData] = useState<any>(null);
  const [isUserModal, setIsUserModal] = useState("");
  const [modalLoading, setModalLoading] = useState(false);
  const [company, setCompany] = useState<any>({
    id: 0,
    name: "",
    domain: "",
    contact_email: "",
    password: "",
    phone: "",
    address: "",
    latitude: "",
    longitude: "",
    total_amount: "",
    count_of_current_employee: "",
    number_of_current_employee: "",
  });
  const [selectedAmount, setSelectedAmount] = useState<any>(null);
  const [customAmount, setCustomAmount] = useState<string>("");
  const [pricingLoading, setPricingLoading] = useState(false);
  const [pricingHistory, setPricingHistory] = useState<any>(null);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [showHistory, setShowHistory] = useState(false);

  const predefinedAmounts = [
    { value: 199, label: "$199 you got +500 minutes" },
    { value:349, label: "$349 you got +1000 minutes" },
    { value: 799, label: "$799 you got +2500 minutes" }
  ];

  const getCompanyData = async (id?: any) => {
    setLoading(true);
    axios({
      URL: `/omw/admin/get-company-subscription/${id || params?.id}`,
      method: "GET",
    })
      .then((res) => {
        const data = res?.data?.data;
        setCompanyData(data);
      })
      .catch((err) => setError(err?.response?.data?.message))
      .finally(() => setLoading(false));
  };

  const getPricingHistory = async (id?: any) => {
    setHistoryLoading(true);
    axios({
      URL: `/omw/admin/get-company-pricing-history/${id || params?.id}`,
      method: "GET",
    })
      .then((res) => {
        const data = res?.data?.data;
        setPricingHistory(data);
      })
      .catch((err) => setError(err?.response?.data?.message))
      .finally(() => setHistoryLoading(false));
  };

  useEffect(() => {
    if (params?.id) {
      getCompanyData(params?.id);
      getPricingHistory(params?.id);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.id]);

  const updateCompanyPricing = async () => {
    const amount = selectedAmount?.value || parseFloat(customAmount);
    
    if (!amount || amount <= 0) {
      setError("Please select or enter a valid amount");
      return;
    }

    setPricingLoading(true);
    await axios({
      URL: `/omw/admin/update-company-pricing/${params?.id}`,
      method: "PUT",
      data: { amount },
    })
      .then((res: any) => {
        getCompanyData(params?.id);
        getPricingHistory(params?.id);
        setSelectedAmount(null);
        setCustomAmount("");
        setError("");
      })
      .catch((err) => {
        setError(err.response?.data?.message);
      })
      .finally(() => {
        setPricingLoading(false);
      });
  };

  const updateCompany = async () => {
    setModalLoading(true);
    const data = {
      ...company,
    };
    await axios({
      URL: `/omw/admin/update-company-subscription/${params?.id}`,
      method: "PATCH",
      data: data,
    })
      .then((res: any) => {
        getCompanyData(params?.id);
      })
      .catch((err) => {
        setError(err.response?.data?.message);
      })
      .finally(() => {
        setModalLoading(false);
      });
  };

  return (
    <ContentLayout className={"items-start"}>
      <div className={"bg-white w-full rounded-2xl flex flex-col overflow-hidden"}>
        <div
          className={"flex p-4 md:p-6 gap-4 md:gap-5 md:flex-row flex-col-reverse flex-wrap"}
        >
          <div className={"flex flex-col w-full max-w-[500px] gap-4 md:gap-5 min-w-0"}>
            <div className={"flex flex-col sm:flex-row justify-between gap-2 sm:gap-4"}>
              <div className={"flex flex-col flex-1 min-w-0"}>
                <p className={"text-sm md:text-base font-bold text-left"}>Name</p>
                <p className={"text-xs md:text-sm text-left break-words"}>
                  {companyData?.name || "-"}
                </p>
              </div>
              <div className={"flex flex-col flex-1 min-w-0"}>
                <p className={"text-sm md:text-base font-bold text-left"}>Domain</p>
                <p className={"text-xs md:text-sm text-left break-words"}>
                  {companyData?.domain || "-"}
                </p>
              </div>
            </div>
            <div className={"flex flex-col sm:flex-row justify-between gap-2 sm:gap-4"}>
              <div className={"flex flex-col flex-1 min-w-0"}>
                <p className={"text-sm md:text-base font-bold text-left flex items-center gap-1"}>
                  Email Address{" "}
                  <ContentCopyIcon
                    className={"cursor-pointer hover:opacity-70"}
                    fontSize="small"
                    onClick={() =>
                      navigator.clipboard.writeText(companyData?.contact_email)
                    }
                  />
                </p>
                <p className={"text-xs md:text-sm text-left break-words"}>
                  {companyData?.contact_email || "-"}
                </p>
              </div>
              <div className={"flex flex-col flex-1 min-w-0"}>
                <p className={"text-sm md:text-base font-bold text-left flex items-center gap-1"}>
                  Phone{" "}
                  <ContentCopyIcon
                    className={"cursor-pointer hover:opacity-70"}
                    fontSize="small"
                    onClick={() =>
                      navigator.clipboard.writeText(companyData?.phone)
                    }
                  />
                </p>
                <p className={"text-xs md:text-sm text-left break-words"}>
                  {companyData?.phone || "-"}
                </p>
              </div>
            </div>
            <div className={"flex flex-col sm:flex-row justify-between gap-2 sm:gap-4"}>
              <div className={"flex flex-col flex-1 min-w-0"}>
                <p className={"text-sm md:text-base font-bold text-left"}>
                  Current Employee
                </p>
                <p className={"text-xs md:text-sm text-left break-words"}>
                  {companyData?.number_of_current_employee || "-"}
                </p>
              </div>
              <div className={"flex flex-col flex-1 min-w-0"}>
                <p className={"text-sm md:text-base font-bold text-left"}>
                  Count Of Current Employee
                </p>
                <p className={"text-xs md:text-sm text-left break-words"}>
                  {companyData?.count_of_current_employee || "-"}
                </p>
              </div>
            </div>
            <div className={"flex flex-col sm:flex-row justify-between gap-2 sm:gap-4"}>
              <div className={"flex flex-col flex-1 min-w-0"}>
                <p className={"text-sm md:text-base font-bold text-left"}>Longitude</p>
                <p className={"text-xs md:text-sm text-left break-words"}>
                  {companyData?.longitude || "-"}
                </p>
              </div>
              <div className={"flex flex-col flex-1 min-w-0"}>
                <p className={"text-sm md:text-base font-bold text-left"}>Latitude</p>
                <p className={"text-xs md:text-sm text-left break-words"}>
                  {companyData?.latitude || "-"}
                </p>
              </div>
              <div className={"flex flex-col flex-1 min-w-0"}>
                <p className={"text-sm md:text-base font-bold text-left"}>Address</p>
                <p className={"text-xs md:text-sm text-left break-words"}>{companyData?.address || "-"}</p>
              </div>
            </div>
            <div className={"flex justify-start gap-2"}>
              <button
                className={
                  "bg-primary text-white p-2.5 md:p-3 w-full sm:w-40 rounded-2xl disabled:cursor-not-allowed disabled:opacity-70 opacity-100 text-sm md:text-base"
                }
                onClick={() => {
                  setIsUserModal("Update");
                  setCompany({
                    ...companyData,
                    id: params?.id,
                  });
                }}
                disabled={loading}
              >
                Edit
              </button>
            </div>
          </div>
          <div className={"flex flex-col flex-1 justify-between min-w-0"}>
            <div className={"flex flex-col gap-3 md:gap-5 items-start md:items-end"}>
              <p className={"text-2xl md:text-4xl font-bold text-left md:text-right w-full md:w-auto"}>Total Amount: </p>
              <p className={"text-2xl md:text-4xl text-left md:text-right break-words w-full md:w-auto"}>
                ${companyData?.total_amount || 0}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Pricing Section */}
      <div className={"bg-white w-full rounded-2xl flex flex-col mt-4 p-3 md:p-4"}>
        <div className={"flex flex-col gap-3 md:gap-4"}>
          <h2 className={"text-lg md:text-xl font-bold"}>Company Pricing</h2>
          
          {/* Current Pricing Display */}
          <div className={"flex flex-col gap-2"}>
            <div className={"flex flex-col sm:flex-row gap-3 sm:gap-4 items-start sm:items-center"}>
              <div className={"flex flex-col flex-1 min-w-0"}>
                <p className={"text-xs font-semibold text-gray-600"}>Total Duration</p>
                <p className={"text-sm md:text-base font-bold break-words"}>
                  ${pricingHistory?.current_duration || companyData?.duration ||"0"} seconds
                </p>
              </div>
              <div className={"flex flex-col flex-1 min-w-0"}>
                <p className={"text-xs font-semibold text-gray-600"}>Remaning Duration</p>
                <p className={"text-sm md:text-base font-bold break-words"}>
                  {pricingHistory?.remaining_duration || companyData?.remaining_duration || "0"} seconds
                </p>
              </div>
            </div>
          </div>

          {/* Pricing Input Section */}
          <div className={"flex flex-col gap-3 border-t pt-3"}>
            <p className={"text-sm md:text-base font-semibold"}>Add Pricing</p>
            <div className={"flex flex-col gap-3"}>
              <div className={"flex flex-col sm:flex-row gap-3"}>
                <div className={"flex-1 flex flex-col gap-1.5 min-w-0"}>
                  <label className={"text-xs font-semibold"}>Select Amount</label>
                  <div className={"w-full"}>
                    <Select
                      options={predefinedAmounts}
                      value={selectedAmount}
                      onChange={(value) => {
                        setSelectedAmount(value);
                        setCustomAmount("");
                      }}
                      placeholder="Select predefined amount"
                      className={"w-full"}
                      isClearable
                      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                      menuPosition="fixed"
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: "38px",
                          fontSize: "14px",
                        }),
                        menu: (base) => ({
                          ...base,
                          zIndex: 99999,
                          maxHeight: "180px",
                        }),
                        menuList: (base) => ({
                          ...base,
                          maxHeight: "180px",
                          overflowY: "auto",
                          padding: "4px 0",
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 99999,
                        }),
                        option: (base) => ({
                          ...base,
                          padding: "8px 12px",
                          fontSize: "14px",
                        }),
                      }}
                    />
                  </div>
                </div>
                {/* <div className={"flex-1 flex flex-col gap-1.5 min-w-0"}>
                  <label className={"text-xs font-semibold"}>Or Enter Custom Amount</label>
                  <input
                    type="number"
                    value={customAmount}
                    onChange={(e) => {
                      setCustomAmount(e.target.value);
                      setSelectedAmount(null);
                    }}
                    placeholder="Enter amount in dollars"
                    className={
                      "bg-white w-full rounded-md p-2 border border-gray outline-none text-sm"
                    }
                    min="0"
                    step="0.01"
                  />
                </div> */}
              </div>
              <button
                className={
                  "bg-primary text-white p-2.5 px-5 rounded-xl disabled:cursor-not-allowed disabled:opacity-70 opacity-100 flex items-center justify-center gap-2 w-full sm:w-auto text-sm"
                }
                onClick={updateCompanyPricing}
                disabled={pricingLoading || (!selectedAmount && !customAmount)}
              >
                {pricingLoading ? (
                  <>
                    <AiOutlineLoading3Quarters className={"animate-spin"} />
                    <span>Updating...</span>
                  </>
                ) : (
                  "Update Pricing"
                )}
              </button>
            </div>
          </div>

          {/* Pricing History Section */}
          <div className={"flex flex-col gap-3 border-t pt-3"}>
            <div className={"flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2"}>
              <p className={"text-sm md:text-base font-semibold"}>Pricing History</p>
              <button
                className={
                  "bg-gray-200 text-gray-700 p-1.5 px-3 rounded-lg text-xs hover:bg-gray-300 w-full sm:w-auto"
                }
                onClick={() => {
                  setShowHistory(!showHistory);
                  if (!showHistory && !pricingHistory) {
                    getPricingHistory(params?.id);
                  }
                }}
              >
                {showHistory ? "Hide History" : "Show History"}
              </button>
            </div>

            {showHistory && (
              <div className={"flex flex-col gap-2 overflow-hidden"}>
                {historyLoading ? (
                  <div className={"flex justify-center items-center p-4"}>
                    <AiOutlineLoading3Quarters className={"animate-spin text-xl"} />
                  </div>
                ) : pricingHistory?.history?.length > 0 ? (
                  <div className={"overflow-x-auto -mx-3 md:-mx-4 px-3 md:px-4"}>
                    <div className={"min-w-full inline-block max-h-[300px] overflow-y-auto"}>
                      <table className={"w-full border-collapse min-w-[600px] text-xs"}>
                        <thead className={"sticky top-0 bg-gray-100 z-10"}>
                          <tr>
                            <th className={"border border-gray-300 p-1.5 text-left text-xs whitespace-nowrap"}>Date</th>
                            <th className={"border border-gray-300 p-1.5 text-left text-xs whitespace-nowrap"}>Old Amount</th>
                            <th className={"border border-gray-300 p-1.5 text-left text-xs whitespace-nowrap"}>New Amount</th>
                            <th className={"border border-gray-300 p-1.5 text-left text-xs whitespace-nowrap"}>Old Duration</th>
                            <th className={"border border-gray-300 p-1.5 text-left text-xs whitespace-nowrap"}>New Duration</th>
                            <th className={"border border-gray-300 p-1.5 text-left text-xs whitespace-nowrap"}>Changed By</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pricingHistory.history.map((record: any, index: number) => (
                            <tr key={record.id || index} className={"hover:bg-gray-50"}>
                              <td className={"border border-gray-300 p-1.5 text-xs whitespace-nowrap"}>
                                {moment(record.created_at).format("MM-DD-YYYY HH:mm:ss")}
                              </td>
                              <td className={"border border-gray-300 p-1.5 text-xs"}>
                                ${record.old_amount || 0}
                              </td>
                              <td className={"border border-gray-300 p-1.5 text-xs font-semibold"}>
                                ${record.new_amount || 0}
                              </td>
                              <td className={"border border-gray-300 p-1.5 text-xs"}>
                                {record.old_duration || "0"}s
                              </td>
                              <td className={"border border-gray-300 p-1.5 text-xs font-semibold"}>
                                {record.new_duration || "0"}s
                              </td>
                              <td className={"border border-gray-300 p-1.5 text-xs"}>
                                {record.changed_by || "-"}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <p className={"text-gray-500 text-center p-3 text-xs"}>No pricing history available</p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <CompanyModal
        open={isUserModal}
        onClose={() => setIsUserModal("")}
        company={company}
        setCompany={setCompany}
        onSubmit={updateCompany}
        isEdit
        loading={modalLoading}
      />
    </ContentLayout>
  );
};

export default Company;
